import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function RecruiterSignup() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/login?role=recruiter', { replace: true }); }, [navigate]);
  return null;
}

export default RecruiterSignup;
